<template lang="pug">
  div.page-layout
    template(v-if="isStandaloneRoute")
      router-view
    template(v-else-if="isMaintenance")
      Header2
      div.main
        router-view
      Footer2
    template(v-else)
      Header
      div.main
        router-view
      Aside
      Footer
  </template>

<script>
import { mapActions } from 'vuex'
import Header from './layout/header/Index.vue'
import Footer from './layout/footer/Index.vue'
import Header2 from './layout/header2/Index.vue'
import Footer2 from './layout/footer2/Index.vue'
import Aside from './layout/Aside.vue'

export default {
  name: 'Layout',
  data () {
    return {
      isMaintenance: false
    }
  },
  async mounted () {
    try {
      const res = await this.getListModel({ name: 'SystemRights' })
      this.useAlternateLayout = this.shouldUseAlternateLayout(res)
      this.isMaintenance = false
    } catch (error) {
      // 進入維護模式
      this.isMaintenance = true
    }
  },
  methods: {
    ...mapActions(['getListModel']),
    shouldUseAlternateLayout (response) {
      // 根據API返回結果決定是否使用替代佈局
      return response && response.someCondition
    }
  },
  computed: {
    isStandaloneRoute () {
      return this.$route.matched.some(route => route.meta && route.meta.standalone)
    }
  },
  components: {
    Header,
    Footer,
    Header2,
    Footer2,
    Aside
  }
}
</script>
